document.addEventListener("DOMContentLoaded", function () {
	// Create a reusable dialog element
	let dialog = document.createElement("dialog");
	dialog.classList.add("bds-lightbox-dialog");
	dialog.setAttribute("role", "dialog");
	dialog.setAttribute("aria-modal", "true");
	dialog.setAttribute("tabindex", "-1");
	document.body.appendChild(dialog);

	// Add a close button
	let closeBtn = document.createElement("button");
	closeBtn.textContent = "×";
	closeBtn.className = "bds-lightbox-close";
	closeBtn.setAttribute("aria-label", "Close dialog");
	dialog.appendChild(closeBtn);

	let lastActiveElement = null;

	function trapFocus(e) {
		const focusableEls = dialog.querySelectorAll(
			'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
		);
		const firstFocusableEl = focusableEls[0];
		const lastFocusableEl = focusableEls[focusableEls.length - 1];

		if (e.key === "Tab") {
			if (e.shiftKey) {
				// shift + tab
				if (document.activeElement === firstFocusableEl) {
					e.preventDefault();
					lastFocusableEl.focus();
				}
			} else {
				// tab
				if (document.activeElement === lastFocusableEl) {
					e.preventDefault();
					firstFocusableEl.focus();
				}
			}
		}
	}

	closeBtn.addEventListener("click", () => dialog.close());

	dialog.addEventListener("click", function (e) {
		if (e.target === dialog) {
			dialog.close();
		}
	});

	dialog.addEventListener("close", () => {
		// Remove all content except the close button
		[...dialog.children].forEach((child) => {
			if (child !== closeBtn) dialog.removeChild(child);
		});
		// Restore focus to last active element
		if (lastActiveElement) lastActiveElement.focus();
	});

	dialog.addEventListener("keydown", function (e) {
		if (e.key === "Escape") dialog.close();
		trapFocus(e);
	});

	// Lightbox for button links
	document
		.querySelectorAll(".wp-block-button.lightbox a")
		.forEach(function (lightbox) {
			const contentId = new URL(lightbox.href).hash;
			const content = document.querySelector(contentId);

			if (content) {
				content.style.display = "none"; // Hide initially
				content.setAttribute("aria-hidden", "true");

				lightbox.addEventListener("click", function (e) {
					e.preventDefault();
					lastActiveElement = lightbox;
					content.style.display = "block";
					content.setAttribute("aria-hidden", "false");
					dialog.appendChild(content);

					// // Set aria-labelledby if content has a heading
					// const heading = content.querySelector("h1, h2, h3, h4, h5, h6");
					// if (heading) {
					// 	dialog.setAttribute("aria-labelledby", heading.id || "dialog-heading");
					// 	if (!heading.id) heading.id = "dialog-heading";
					// } else {
					// 	dialog.removeAttribute("aria-labelledby");
					// }

					dialog.showModal();
					closeBtn.focus();
				});

				dialog.addEventListener("close", function () {
					content.style.display = "none";
					content.setAttribute("aria-hidden", "true");
					document.body.appendChild(content); // Restore to original place
				});
			}
		});

	// Lightbox for gallery images
	document
		.querySelectorAll(".wp-block-gallery a")
		.forEach(function (galleryLink) {
			galleryLink.addEventListener("click", function (e) {
				e.preventDefault();
				lastActiveElement = galleryLink;
				const img = document.createElement("img");
				img.src = galleryLink.href;
				img.alt =
					galleryLink.querySelector("img")?.alt || "Gallery image";
				img.style.maxWidth = "90vw";
				img.style.maxHeight = "80vh";
				img.setAttribute("aria-describedby", "dialog-img-desc");

				// Remove previous images
				[...dialog.children].forEach((child) => {
					if (child !== closeBtn) dialog.removeChild(child);
				});
				dialog.appendChild(img);

				// Optionally add a description for screen readers
				let desc = document.createElement("div");
				desc.id = "dialog-img-desc";
				desc.style.position = "absolute";
				desc.style.left = "-9999px";
				desc.textContent =
					"Image preview in modal dialog. Press Escape to close.";
				dialog.appendChild(desc);

				dialog.showModal();
				closeBtn.focus();
			});
		});
});
